module.exports = __webpack_public_path__ + "img/serviceQrcode.6596cf5a.png";